import * as React from 'react';

import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger/shared';

import { GalleryControlsContainer } from './controls/container';
import { FotoramaContainer } from './fotorama/container';
import { FotoramaTourContainer } from './fotorama_tour/container';
import { PromoContainer } from './promo/container';

import * as styles from './index.css';
import { CountrysidePromoLabelContainer } from '../CountrysidePromotionsLabel/container';
import { TourThumbnailsContainer } from './fotorama_tour/TourThumbnails';

export interface IOfferGalleryProps {
  reactErrorLogger: ILogger;
  isTourAvailable?: boolean;
}

export class OfferGallery extends React.Component<IOfferGalleryProps, {}> {
  public render() {
    const { reactErrorLogger, isTourAvailable = false } = this.props;

    return (
      <div className={styles['photo_gallery_container']} id="photos">
        <ErrorLogComponent logger={reactErrorLogger}>
          {isTourAvailable ? <FotoramaTourContainer /> : <FotoramaContainer />}
        </ErrorLogComponent>
        {!isTourAvailable && <GalleryControlsContainer />}
        {isTourAvailable && <TourThumbnailsContainer />}
        <PromoContainer />
        <CountrysidePromoLabelContainer />
      </div>
    );
  }
}
